const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { saveLastVisitedView } from '@/lib/utils/loop-visualizations/lastVisitedVisualizationView';
const paramsSchema = z.object({
  viewId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/view/$viewId')({
  params: paramsSchema,
  loader: ({
    params
  }) => saveLastVisitedView(Number(params.loopId), {
    type: 'view',
    id: Number(params.viewId)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});